import { ValidatorFn, AbstractControl } from "@angular/forms";

const regex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validatorEmailFNC = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const isValid = regex.test(control.value);
        return !isValid ? { 'DOESNOT_MATCHED_EMAIL_REGEX': control.value } : null;
    };
}